<!--
 * @Description: 教师空间-学生学习记录-笔记
 * @Author: PF
 * @Date: 2025-07-02 15:12:24
 * @LastEditors: PF
 * @LastEditTime: 2025-10-30 09:38:43
-->
<template>
  <el-container>
    <el-main class="pl0 pr0">
      <el-table v-loading="dataGrid.loading" :data="dataGrid.data" border ref="table" height="100%">
        <el-table-column type="expand" fixed="left">
          <template #default="props">
            <div class="pl10 pr10">
              <span>{{ props.row.commentUserName }}</span> 在
              <span style="color:#868686">{{ props.row.commentDate }}</span> 作出评价
              <div class="commonText" v-html="props.row.commentContent" style="white-space:pre-wrap"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="序号" type="index" align="center" fixed="left" width="60" />
        <el-table-column label="网络课程" prop="netCourseName" show-overflow-tooltip min-width="150" align="center" />
        <el-table-column label="星级" width="150" align="center">
          <template #default="scope">
            <el-rate v-model="scope.row.commentScore" disabled text-color="#ff9900"></el-rate>
          </template>
        </el-table-column>
        <el-table-column label="评价时间" prop="commentDate" width="160" align="center" />
        <el-table-column label="操作" width="120px" align="center" fixed="right" v-if="!dataGrid.parms.isJs">
          <template #default="scope">
            <el-link :underline="false" type="danger" @click="remove(scope.row.id)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="pl0 pr0">
      <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
    </el-footer>
  </el-container>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue'
import { loadList, actionPost } from '@/api/common.js'
import { warningLePrompt, successLePrompt } from '@/utils/promptInfo'
import pagination from '@/components/pagination.vue'

const props = defineProps({ row: { type: Object, required: true } })
const emits = defineEmits(['ReturnData'])

const dataGrid = ref({
  parms: {},
  data: [
  {
    "id": "1417443206777278464",
    "remarks": "",
    "createBy": "1022453291755241472",
    "createByName": "李荟妍",
    "createDate": "2025-09-16 09:33:15",
    "updateBy": "1022453291755241472",
    "updateByName": "李荟妍",
    "updateDate": "2025-09-16 09:33:15",
    "delFlag": "0",
    "netCourseId": "1417156630352498688",
    "netCourseName": "语言文学（刘老师）",
    "commentUserId": "1022453291755241472",
    "commentUserPhoto": "/common/photo/202508/22/1408387198721462272.jpeg",
    "commentFloor": null,
    "commentUserName": "李荟妍",
    "commentScore": 4,
    "commentContent": "44444",
    "commentDate": "2025-09-16 09:33:15",
    "sId": "1",
    "number": null
  }
],
  pagination: {},
  loading: false,
  orderBy: { prop: 'netCourseName', order: 'ascending' },
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.isAll = 0
  loadList({
    url: '',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value
  })
}

// 删除
const remove = async (id) => {
  ElMessageBox.confirm('确定要删除吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    dataGrid.value.loading = true
    const options = { url: '', data: { id: id } }
    actionPost(options).then((res) => {
      dataGrid.value.loading = false
      if (res.code === 200) {
        bindTable()
        successLePrompt(res.message)
      } else {
        warningLePrompt(res.message)
      }
    })
  })
}

watch(
  () => props.row,
  () => {
    if (props.row) {
      dataGrid.value.parms = props.row
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style scoped>
.commonText {
  margin-top: 10px;
  line-height: 22px;
  text-indent: 2em;
}
</style>